import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StudentForm from './StudentForm';
import { experiences } from '../../data/demoForm';
import { url } from "../../data/url";

const BackArrowIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Experience = ({ isVisible, toggleFilters }) => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [showFullScreenImage, setShowFullScreenImage] = useState(false);

    axios.defaults.withCredentials = true;

    useEffect(() => {
        fetchUserData();
    }, []);
    
    const fetchUserData = async () => {
        try {
            const response = await axios.get(`${url.path}/user/select-company`, { withCredentials: true });
            setUserData(response.data);
            if(response.data && response.data.companySelected != null)
            {
                setSelectedCompany(response.data.companySelected);
            }
        } catch (error) {
            if(error.response && error.response.status === 401) {
                navigate('/signin');
            }
            console.error('Error fetching user data:', error);
        }
    };

    const handleBackClick = () => {
        toggleFilters();
    };

    const toggleStep = (step) => {
        setCurrentStep(step);
    };
    
    const toggleSelectCompany = (company) => {
        setSelectedCompany(company);
    };

    const handleCardClick = () => {
        setShowFullScreenImage(true);
    };

    const handleCloseFullScreenImage = () => {
        setShowFullScreenImage(false);
    };

    if (!userData) {
        return <div>Loading...</div>; 
    }

    if (userData.companySelected === null || (isVisible && isVisible === true)) {
        return <StudentForm onCompanySelected={fetchUserData} toggleFilters={toggleFilters} isVisible={isVisible} toggleStep={toggleStep} currentStep={currentStep} selectedCompany={selectedCompany} toggleSelectCompany={toggleSelectCompany}/>;
    }

    const handleExperienceClick = () => {
        navigate('/user/training-room');
    };

    return (
        <div className="experience-form">
            {showFullScreenImage ? (
                <div className="full-screen-image" onClick={handleCloseFullScreenImage}>
                    <button className="close-button" onClick={handleCloseFullScreenImage}>Close</button>
                    <img src="https://i.postimg.cc/25wRtW4z/Placeholder.png" alt="Full-screen placeholder" />
                </div>
            ) : (
                <div className="experience-container">
                    <div className="header">
                        <button onClick={handleBackClick} className="back-button">
                            <BackArrowIcon />
                        </button>
                        <h1>
                            {`Welcome to the ${userData.companySelected} Experience`}
                        </h1>
                        <p>Practice the sales skills below to develop essential job related soft skills</p>
                    </div>
                    <div className="experience-grid">
                        {experiences.map((experience, index) => (
                            <button onClick={handleCardClick} className="experience-card" key={index}>
                                <h3>{experience.title}</h3>
                                {/* <p>{experience.description}</p> */}
                                <div className="experience-info">
                                    <i className="icon-microphone"></i> {experience.duration}
                                </div>
                            </button>
                        ))}
                    </div>
                    <div className="footer">
                        <button className="experience-more-btn" onClick={handleExperienceClick}>EXPERIENCE MORE</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Experience;